module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_m_normal.89f3c3f7.png";